export const GET_ENTRIES_REQUEST = 'GET_ENTRIES_REQUEST'
export const GET_ENTRIES_SUCCESS = 'GET_ENTRIES_SUCCESS'
export const GET_ENTRIES_FAIL = 'GET_ENTRIES_FAIL'
export const GET_ENTRIES_RESET = 'GET_ENTRIES_RESET'
